import { useEffect, useState } from "react"

/**
 * "now" for the temperature demo, refreshed once a minute. The generator is
 * minute-resolution, so a faster tick would only cost renders.
 */
export const useDemoNow = (): Date => {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000)
    return () => clearInterval(id)
  }, [])
  return now
}
